import { useActivitiesQuery, useParamsQuery } from '../../hooks/useQueries';

import type { Activity as ActivityType } from '../../models/activity';
import type { ActivityValues } from '@insify/funnel-components';

export const useActivityValues = (): ActivityValues<ActivityType> => {
  const { data: query, isFetched } = useParamsQuery();
  const { data: activities } = useActivitiesQuery();

  const suggestions = isFetched ? query?.company?.registeredActivities ?? [] : undefined;

  const selected = isFetched ? query?.activities ?? [] : undefined;

  return {
    activities,
    selected,
    suggestions,
  };
};
